<template>
  <el-form class="login-form" :rules="loginRules" ref="loginForm" :model="loginForm" label-width="0"
           v-loading="isLoginLoading">
    <el-form-item prop="username" class="align-left">
      <el-input @keyup.enter.native="handleLogin" v-model="loginForm.username" auto-complete="off"
                @input="recover"
                @change="handleUserChange"
                @blur="getIsOpenSmsCodeVerifyByAccount"
                size="large"
                placeholder="请输入用户名">
        <fa slot="prefix" icon="user" style="font-size: 16px;position: relative;top: 7px;left: 5px;"></fa>
      </el-input>
      <el-tooltip placement="top" content="本系统使用集采平台账号登录">
        <!-- <span style="color: #666; font-size: 24px; padding-left: 4px;">?</span> -->
        <i class="el-icon-question" style="color: #444; font-size: 24px; padding-left: 4px;"></i>
      </el-tooltip>
    </el-form-item>
    <el-form-item prop="password" style="margin-bottom: 20px" class="align-left">
      <el-input @keyup.enter.native="handleLogin" :type="passwordType" v-model="loginForm.password"
                size="large"
                auto-complete="off" placeholder="请输入密码">
        <i class="el-icon-view el-input__icon" slot="suffix" @click="showPassword"></i>
        <fa slot="prefix" icon="lock" style="font-size: 16px;position: relative;top: 7px;left: 5px;"></fa>
      </el-input>
    </el-form-item>
    <el-form-item prop="smsCode" style="margin-bottom: 20px" class="align-left" v-if="msmCodeVisiBle">
      <el-input
        size="large"
        v-model="loginForm.smsCode"
        type="text"
        placeholder="手机验证码"
      >
        <el-button
          @click.native.prevent="getObtainCode"
          type="text"
          class="codebtn"
          :disabled="totalTime>0"
          slot="suffix"
        >
          {{ btnText }}
        </el-button>
      </el-input>
      <el-row style="color: #c2bbbb;font-size: 12px" v-if="mobilePhone">用于接受手机验证码的手机号：{{mobilePhone}}</el-row>
    </el-form-item>
    <el-form-item prop="code">
      <el-button type="primary" @click.native.prevent="handleLogin" class="login-submit">登 录</el-button>
    </el-form-item>

    <!--手机验证码弹窗-->
    <div class="mobile-check" v-if="isShowMobileCheck">
      <div class="mobile-check-container">
        <el-card>
          <div>
            <span style="font-size: 25px; color: #499ddb; font-weight: bolder">密码验证</span>
            <div style="float: right; color: #499ddb; font-size: 25px; cursor: pointer;" @click="cancelCheck">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <div style="padding: 20px 20px 0">
            <div style="margin-bottom: 10px">
              <span style="font-size: 16px">请输入验证码：</span>
            </div>
            <div style="margin-bottom: 20px">
              <el-input style="display: inline-block; width: 312px;" v-model="checkCode"></el-input>
              <el-button type="primary"
                         :disabled="timeNum == '' ? false : true"
                         @click="getCheckCode">{{timeNum}}发送验证码
              </el-button>
            </div>
            <div style="display: flex; justify-content: space-around">
              <div>
                <el-button @click="cancelCheck">取消</el-button>
              </div>
              <div>
                <el-button type="primary" :loading="isLoadingCheck" @click="defineCheck">确定</el-button>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!--重置密码页面-->
    <div class="mobile-check" v-if="isShowResetPassword">
      <div class="mobile-check-container">
        <el-card>
          <div>
            <span style="font-size: 25px; color: #499ddb; font-weight: bolder">密码重置</span>
            <div style="float: right; color: #499ddb; font-size: 25px; cursor: pointer" @click="cancelReset">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <div style="padding: 20px 20px 0">
            <div style="margin-bottom: 10px">
              <span style="font-size: 16px">请输入新密码:</span>
            </div>
            <div style="margin-bottom: 10px">
              <el-input v-model="newPassword" type="password"></el-input>
            </div>
            <div style="margin-bottom: 10px">
              <span style="font-size: 16px">请再次输入密码:</span>
            </div>
            <div style="margin-bottom: 10px">
              <el-input v-model="newPasswordAgain" type="password"></el-input>
            </div>
            <div style="display: flex; justify-content: space-around">
              <div>
                <el-button @click="cancelReset">取消</el-button>
              </div>
              <div>
                <el-button type="primary" :loading="isLoadingReset" @click="defineReset">确定</el-button>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </el-form>
</template>

<script>
  import {isvalidUsername} from "@/util/validate";
  import LoginApi from "@/api/LoginApi";
  import {randomLenNum, convertToRoute, convertToMenu} from "@/util/util";
  import {mapGetters} from "vuex";

  let fetchLabel = null
  export default {
    name: "userlogin",
    data() {
      const validateUsername = (rule, value, callback) => {
        if (!isvalidUsername(value)) {
          callback(new Error("请输入正确的用户名"));
        } else {
          callback();
        }
      };
      const validateCode = (rule, value, callback) => {
        if (this.code.value != value) {
          this.loginForm.code = "";
          this.refreshCode();
          callback(new Error("请输入正确的验证码"));
        } else {
          callback();
        }
      };
      return {
        loginForm: {
          username: "",
          password: "",
          code: "",
          redomStr: "",
          smsCode: "",
          specialType: '1'
        },
        checked: false,
        code: {
          src: "",
          value: "",
          len: 4,
          type: "text"
        },
        loginRules: {
          username: [
            /*{ required: true, trigger: "blur", validator: validateUsername }*/
            {required: true, message: "请输入用户名", trigger: "blur"}
          ],
          password: [
            {required: true, message: "请输入密码", trigger: "blur"}/*,
                        {min: 6, message: "密码长度最少为6位", trigger: "blur"}*/
          ],
          code: [
            {required: true, message: "请输入验证码", trigger: "blur"},
            {min: 4, max: 4, message: "验证码长度为4位", trigger: "blur"},
            {required: true, trigger: "blur", validator: validateCode}
          ],
          smsCode: [
            {required: true, message: "请输入验证码", trigger: "blur"},
            {min: 6, max: 6, message: "验证码长度为6位", trigger: "blur"},
          ],
        },
        passwordType: "password",
        isLoginLoading: false, //控制登录按钮动画加载

        appId: process.env.SSO_APP_ID, //线上环境
        tokenStr: '',

        isShowMobileCheck: false, //控制验证框是否显示
        isLoadingCheck: false, //控制验证码的按钮过度动画加载
        timeNum: '', //点击验证时倒数的秒数
        mobelNum: '', //验证时的手机号
        checkCode: '', //验证码

        isShowResetPassword: false, //控制重置密码弹窗是否显示
        isLoadingReset: false, //控制重置密码的按钮过度动画加载
        newPassword: '', //新密码
        newPasswordAgain: '', //再次确认新密码

        // 验证码部分
        msmCodeVisiBle: false,
        btnText: "发送验证码",
        totalTime: 0,
        loginApi: new LoginApi(),
        mobilePhone: '',
        cachedUsername: '',
      };
    },
    created() {
      this.refreshCode();
    },
    mounted() {
    },
    computed: {
      ...mapGetters(["tagWel"])
    },
    props: [],
    methods: {
      handleUserChange(v){
        if(v!==this.cachedUsername){
          this.msmCodeVisiBle = false;
          this.mobilePhone = ''
          this.totalTime = 0;
          this.btnText = "重新发送验证码"
          if(this.clock){
            clearInterval(this.clock)
            this.clock = null;
          }
        }
      },
      // 获取倒计时
      countdown() {
        this.clock = window.setInterval(() => {
          this.totalTime--;
          this.btnText = this.totalTime + "s后重新发送";
          if (this.totalTime < 0) {
            window.clearInterval(this.clock);
            this.btnText = "重新发送验证码";
            this.totalTime = 0;
          }
        }, 1000);
      },
      // 恢复之前的样式
      recover() {
        this.loginForm.smsCode = '';
        this.btnText = "发送验证码";
        this.msmCodeVisiBle = false;
        if (this.clock) {
          window.clearInterval(this.clock);
        }
      },
      // 获取是否需要短信验证
      getIsOpenSmsCodeVerifyByAccount() {
        if (this.loginForm.username) {
          this.totalTime = 0;
          window.clearInterval(this.clock);
          fetchLabel = this.loginApi.isOpenSmsCodeVerifyByAccount({
            account: this.loginForm.username,
            appId: this.appId
          }).then(res => {
            if (res.data.openSms) {
              this.msmCodeVisiBle = true;
              this.mobilePhone = res.data.mobilePhone;
              this.totalTime = res.data.expireTime;
              if (this.totalTime > 0) {
                this.btnText = this.totalTime + "s后重新发送";
                this.countdown();
              } else if (this.totalTime <= 0 || this.totalTime < 0) {
                this.btnText = "发送验证码";
                this.totalTime = 0;
              }
            } else {
              this.msmCodeVisiBle = false;
            }
          }).catch((e) => {
            console.log(e);
            this.totalTime = 0;
            this.msmCodeVisiBle = false;
          });
          return fetchLabel
        }
      },
      // 点击发送验证码
      getObtainCode() {
        if (this.totalTime > 0) return;
        this.loginApi.getSmsCode({account: this.loginForm.username, appId: this.appId}).then(res => {
          if (res.code === 200) {
            this.cachedUsername = this.loginForm.username;
            this.totalTime = res.data;
            this.btnText = res.data + "s后重新发送";
            this.countdown();
          } else null
        })
      },
      refreshCode() {
        this.loginForm.redomStr = randomLenNum(this.code.len, true);
        this.code.type == "text"
          ? (this.code.value = randomLenNum(this.code.len))
          : (this.code.src = `${this.codeUrl}/${this.loginForm.redomStr}`);
        this.loginForm.code = this.code.value;
      },
      showPassword() {
        this.passwordType == ""
          ? (this.passwordType = "password")
          : (this.passwordType = "");
      },
      //存储token并且跳转到首页
      setToken(token) {
        //存储token
        this.$store.dispatch("setToken", token)
        this.$store.dispatch("setAppId", process.env.APP_ID)
        //登录到sso
        window.location.href = process.env.SSO_HOST + "/ibs/loginOaNew?appId=" + process.env.SSO_APP_ID + "&token=" + token
        /*  LoginApi.loginSso({token: token,appId: process.env.SSO_APP_ID}).then(res=>{
           if(res.code==1){
               location.assign(res.data)
           }
         }).catch(e=>{
           console.log(e)
         }) */
      },
      //点击登录
      async handleLogin() {
        if (!this.msmCodeVisiBle) {
          if(fetchLabel){
            await fetchLabel
            fetchLabel = null;
          }
          else{
            await this.getIsOpenSmsCodeVerifyByAccount()
          }
          this.$nextTick(()=>{
            this.logIn()
          })
        }else {
          this.logIn();
        }
      },
      // 登录
      logIn() {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            try {
              this.isLoginLoading = true
              //登录
              let loginApi = new LoginApi();
              loginApi.login(this.loginForm, this.appId).then(res => {
                if (res.code == 1) {
                  this.isLoginLoading = false
                  if (this.loginForm.password.match(/^\d+$/)) {
                    this.$confirm("您的密码过于简单,请前往人力系统修改").then(() => {
                      location.assign("https://hr.cncecoa.com/hr/home")
                    }).catch(() => {
                      this.setToken(res.data)
                    })
                  } else {
                    this.setToken(res.data)
                  }
                } else {
                  this.isLoginLoading = false;
                }
              });
            } catch (e) {
              this.isLoginLoading = false;
            } finally {
              this.isLoginLoading = false;
            }
          }
        });
      },
      //点击发送验证码
      getCheckCode() {
        this.timeNum = 60
        let timer = setInterval(() => {
          this.timeNum -= 1
          if (this.timeNum == 0) {
            this.timeNum = ''
            clearInterval(timer)
          }
        }, 1000)
        let loginApi = new LoginApi();
        let data = {
          phone: this.mobelNum,
          appId: this.appId
        }
        loginApi.sendMessage(data).then(res => {
        })
      },
      //确定验证
      defineCheck() {
        if (this.checkCode) {
          this.isLoadingCheck = true
          let loginApi = new LoginApi();
          let data = {
            phone: this.mobelNum,
            code: this.checkCode,
            appId: this.appId
          }
          loginApi.validateCode(data).then(res => {
            if (res.code == 1) {
              this.isLoadingCheck = false
              this.setToken(res.data)
              this.cancelCheck()
            }
          }).catch(e => {
            this.isLoadingCheck = false
            if (e.code == 4) {
              this.tokenStr = e.data
              this.cancelCheck()
              this.isShowResetPassword = true
            }
          })
        } else {
          this.$message.error('请输入验证码！')
        }
      },
      //取消验证
      cancelCheck() {
        this.isShowMobileCheck = false
        this.mobelNum = ''
      },
      //确定重置密码
      defineReset() {
        if (this.newPassword === this.loginForm.password) {
          this.$message.error('新密码不能和旧密码一样，请重新输入！')
          this.newPassword = ''
          this.newPasswordAgain = ''
        } else if (this.newPassword !== this.newPasswordAgain) {
          this.$message.error('两次密码输入不一样，请再次确认密码！')
        } else {
          this.isLoadingReset = true
          let loginApi = new LoginApi();
          let data = {
            account: this.loginForm.username,
            oldPassword: this.loginForm.password,
            newPassword: this.newPassword,
            appId: this.appId
          }
          loginApi.resetPassword(data).then(res => {
            if (res.code == 1) {
              this.isLoadingReset = false
              this.setToken(this.tokenStr)
              this.cancelReset()
            }
          })
        }
      },
      //取消重置密码
      cancelReset() {
        this.isShowResetPassword = false
        this.newPassword = ''
        this.newPasswordAgain = ''
      },
    },
    beforeDestroy(){
      fetchLabel = null;
    }
  };
</script>

<style lang="scss" scoped>
  .mobile-check {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 99;
  }

  .mobile-check-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    width: 570px;
  }

  .codebtn {
    height: 100%;
    text-align: center;
    line-height: 40px;
    padding: 0;
  }
</style>
